import React, { FC } from "react";
import { SettingOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import FormInput from "../../pages/form-components/InputComponent";

interface SequenceInputProps {
  name?: string;
  label: string;
  numberingMode: "auto" | "manual";
  onSettingsClick: () => void;
  showSettingsIcon?: boolean;
  maxLength?: number;
  pattern?: RegExp;
  placeholder?: string;
}

const SequenceInput: FC<SequenceInputProps> = ({
  name = "referenceID",
  label,
  numberingMode,
  onSettingsClick,
  showSettingsIcon = true,
  maxLength = 20,
  pattern = /^[a-zA-Z0-9./_-]+$/,
  placeholder,
}) => {
  return (
    <div style={{ position: "relative" }}>
      <FormInput
        name={name}
        label={label}
        required={numberingMode === "manual"}
        type="text"
        pattern={pattern}
        maxLength={maxLength}
        disabled={numberingMode === "auto"}
        placeholder={
          placeholder ||
          (numberingMode === "auto" ? "Auto-generated" : `Enter ${label}`)
        }
      />
      {showSettingsIcon && (
        <Tooltip
          title={`Click here to enable or disable auto-generation of ${label} numbers.`}
        >
          <SettingOutlined
            style={{
              position: "absolute",
              right: "10px",
              top: "50px",
              transform: "translateY(-50%)",
              cursor: "pointer",
              fontSize: "18px",
              color: "#1890ff",
              zIndex: 1,
            }}
            onClick={onSettingsClick}
          />
        </Tooltip>
      )}
    </div>
  );
};

export default SequenceInput;
